import styles from "./Item.module.scss";
import { Link } from "react-router-dom";

import SVG from "react-inlinesvg";
import { Text } from "../../../shared/components";
import {
  FONT_COLOR,
  FONT_SIZE,
  FONT_WEIGHT,
  LINE_CLAMP,
} from "../../../shared/components/Text/types";
import { STATUS } from "../NewSideBar/types";
import { useTranslation } from "react-i18next";

export function Item(props) {
  const {
    id,
    label,
    path,
    icon,
    location,
    status,
    collapsed,
    handleSelected,
    selected,
  } = props;

  const { t: translations } = useTranslation(["sidebar"]);

  return (
    <Link
      key={label}
      to={path}
      onClick={() => handleSelected(id)}
      className={`${styles.SidebarItemWrapper} ${
        selected === id ? styles.active : ""
      }`}
    >
      <SVG
        src={icon}
        title={label}
        className={location.pathname === path ? styles.active : ""}
      />
      {!collapsed && (
        <Text
          value={label}
          fontSize={FONT_SIZE.SM}
          lineClamp={LINE_CLAMP.LINE_CLAMP_1}
          fontColor={
            selected === id
              ? FONT_COLOR.OTHERS.BLUE_LIGHT
              : FONT_COLOR.OTHERS.WHITE
          }
        />
      )}
      {!collapsed && status === STATUS.BETA && (
        <Text
          value={translations("sidebar:beta")}
          fontWeight={FONT_WEIGHT.BOLD}
          fontSize={FONT_SIZE.XS}
          lineClamp={LINE_CLAMP.LINE_CLAMP_1}
          fontColor={FONT_COLOR.OTHERS.BLUE_DARK}
        />
      )}
      {!collapsed && status === STATUS.DEMO && (
        <Text
          value={translations("sidebar:demo")}
          fontWeight={FONT_WEIGHT.BOLD}
          fontSize={FONT_SIZE.XS}
          lineClamp={LINE_CLAMP.LINE_CLAMP_1}
          fontColor={FONT_COLOR.OTHERS.BLUE_DARK}
        />
      )}
      {!collapsed && status === STATUS.INACTIVE && (
        <Text
          value={translations("sidebar:inactive")}
          fontWeight={FONT_WEIGHT.BOLD}
          fontSize={FONT_SIZE.XS}
          lineClamp={LINE_CLAMP.LINE_CLAMP_1}
          fontColor={FONT_COLOR.OTHERS.RED}
        />
      )}
      {!collapsed && status === STATUS.NEW && (
        <Text
          value={translations("sidebar:new")}
          fontWeight={FONT_WEIGHT.BOLD}
          fontSize={FONT_SIZE.XS}
          lineClamp={LINE_CLAMP.LINE_CLAMP_1}
          fontColor={FONT_COLOR.OTHERS.BLUE_DARK}
        />
      )}
    </Link>
  );
}
